import {
  Box,
  Button,
  Card,
  CardBox,
  Inline,
  Link,
  Stack,
  Text,
} from '@amboss/design-system';
import { useTranslation } from 'react-i18next';
import { createSearchParams, useNavigate, useSearchParams } from 'react-router-dom';
import { config } from '../../../config';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux';
import { CreditAssociation, CreditType } from '../../../interfaces/credit';
import { setCreditType } from '../../../store/credits/creditsSlice';
import { selectUser } from '../../../store/profile/profileSlice';
import styles from './HomeSectionsCard.module.css';

declare type HomeSectionsCardProps = {
  type: string;
  credits: any;
};

export const HomeSectionsCard = ({ type, credits }: HomeSectionsCardProps) => {
  const { t } = useTranslation();
  const profile = useAppSelector(selectUser);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();
  const navigateToSection = () => {
    navigate({ pathname: '/credits', search: `?${createSearchParams(searchParams)}` });
    dispatch(setCreditType(type));
  };
  return (
    <Card>
      <CardBox>
        <div className='home-card-header'>
          <h3>{t(`home.cards.${type}.title`)}</h3>
        </div>
        <Box space='zero' tSpace='m' bSpace='m'>
          <Inline alignItems='center' space='m'>
            {type === CreditType.IPC && (
              <Stack alignItems='center' space='zero'>
                <p className={styles.creditPointsText}>{credits?.['to-review']}</p>
                <Text
                  align='center'
                  size='xs'
                  color='tertiary'
                  className={styles.creditPointsTitle}
                >
                  {t(`home.labels.toReview`, {
                    count: credits?.['to-review'],
                    type:
                      profile.association === CreditAssociation.AHPRA ? 'HOUR' : 'CREDIT',
                  })}
                </Text>
              </Stack>
            )}
            <Stack alignItems='center' space='zero'>
              <p className={styles.creditPointsText}>{credits?.reviewed}</p>
              <Text
                align='center'
                size='xs'
                color='tertiary'
                className={styles.creditPointsTitle}
              >
                {t(`home.labels.toClaim`, {
                  count: credits?.reviewed,
                  type:
                    profile.association === CreditAssociation.AHPRA &&
                    type === CreditType.IPC
                      ? 'HOUR'
                      : 'CREDIT',
                })}
              </Text>
            </Stack>
          </Inline>
        </Box>
        <div className='home-card-text'>
          <Text size='s'>
            {t(`home.cards.${type}.description`, { context: profile.association })}
          </Text>
        </div>
        <Box space='zero' tSpace='xs'>
          <Inline alignItems='spaceBetween' vAlignItems='center'>
            <Link
              href={`${config.creditsLinks[type]}`}
              color='accent'
              size='s'
              target='_blank'
              rel='noopener noreferrer'
            >
              {t(`home.labels.learnMore`)}
            </Link>
            <Button onClick={navigateToSection} size='s' variant='primary'>
              {profile?.association === 'ahpra' && type === 'ipc'
                ? t(`home.labels.claimHours`)
                : t(`home.labels.claimCredits`)}
            </Button>
          </Inline>
        </Box>
      </CardBox>
    </Card>
  );
};
